/**
 * Company people — the sales contacts we deal with and the users on the
 * customer's dashboard account. Both feed the shipment Contacts tab's
 * "Send Email to Customer" recipient picker.
 *
 * Inline rather than fixture-backed because both endpoints are per-company
 * (`?companyId=`) and MSW serves fixtures by path alone: the real
 * `list-sales-contacts` export holds every contact in the business, which
 * would flood the picker with hundreds of unrelated addresses.
 *
 * The people below belong to the company on the shipment fixtures
 * (Whistler Contemporary Gallery).
 */
export const COMPANY_PEOPLE_INLINE_RESPONSES: Record<string, unknown[]> = {
  "/apollo/companies/list-sales-contacts-for-company": [
    {
      salesContactId: "3f5e1a2c-9d84-4b71-8c60-1e2f3a4b5c6d",
      companyId: "6c1c3c47-ed46-4995-9ca9-a2a8b0a48d24",
      name: "Raymond H",
      email: "raymond@offpistefinearts.com",
      phone: "(604) 935-3999",
      description: "Owner — books most shipments",
      inactive: false,
    },
    {
      salesContactId: "7a1b2c3d-4e5f-4061-9273-8a9b0c1d2e3f",
      companyId: "6c1c3c47-ed46-4995-9ca9-a2a8b0a48d24",
      name: "Dana Whitfield",
      email: "dana@offpistefinearts.com",
      phone: "(604) 935-3998",
      description: "Accounts payable",
      inactive: false,
    },
    {
      salesContactId: "b2c3d4e5-f607-4182-a394-b5c6d7e8f901",
      companyId: "6c1c3c47-ed46-4995-9ca9-a2a8b0a48d24",
      name: "Former Shipping Coordinator",
      email: "shipping-old@offpistefinearts.com",
      phone: "(604) 935-3997",
      inactive: true,
    },
  ],
  "/apollo/companies/get-company-users": [
    {
      email: "raymond@offpistefinearts.com",
      name: "Raymond H",
      userId: "auth0|64c1f0a2b3d4e5f60718293a",
      lastLoginAt: "2026-03-18T15:42:11.183Z",
      phone: "6049353999",
      phoneExtension: "",
      accountingNotificationsEnabled: false,
      allShipmentNotificationsEnabled: true,
      deliveryNotificationsOnlyEnabled: false,
      allowedToSwitchToLinkedCompanies: false,
    },
    {
      email: "orders@offpistefinearts.com",
      name: "Gallery Orders",
      userId: "auth0|64c1f0a2b3d4e5f60718293b",
      lastLoginAt: "2026-03-20T09:05:47.902Z",
      phone: "6049353996",
      phoneExtension: "204",
      accountingNotificationsEnabled: true,
      allShipmentNotificationsEnabled: false,
      deliveryNotificationsOnlyEnabled: true,
      allowedToSwitchToLinkedCompanies: false,
    },
  ],
};
